import React, { useEffect, useRef, useState } from 'react';
import * as styles from './summary-config-button.module.scss';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { PRC_MEETING_SUMMARY_TABLES_KEYS, PRC_MEETING_SUMMARY_TABLES_OPTIONS } from '../../constants';
import { AiCheckBox, BasicButton } from '../../../../assets/common';
import { sp_card_setting } from '../../../../assets/img';
import { pdcMeetingApi } from '../../../../services/pdcMeetingApi';
import { useDispatch } from 'react-redux';
import { setSelectedKey } from '../../redux/pdcSummaryTableViewtSlice';

const SummaryConfigButton = () => {
  const ref = useRef();
  const { idMeeting } = useParams();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [displaySelectedKeys, setDisplaySelectedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(PRC_MEETING_SUMMARY_TABLES_KEYS.ALL);

  const handleSelectedKeys = (value) => {
    let keys = [];

    if (value === PRC_MEETING_SUMMARY_TABLES_KEYS.ALL) {
      keys = PRC_MEETING_SUMMARY_TABLES_OPTIONS.map((option) => option.value);

      if (displaySelectedKeys.length === PRC_MEETING_SUMMARY_TABLES_OPTIONS.length) {
        keys = [];
      }
    }

    if (value !== PRC_MEETING_SUMMARY_TABLES_KEYS.ALL) {
      keys = displaySelectedKeys.filter((key) => key !== PRC_MEETING_SUMMARY_TABLES_KEYS.ALL && key !== value);

      if (!displaySelectedKeys.includes(value)) {
        keys = [...keys, value];

        if (keys.length === PRC_MEETING_SUMMARY_TABLES_OPTIONS.length - 1) {
          keys = [...keys, PRC_MEETING_SUMMARY_TABLES_KEYS.ALL];
        }
      }
    }

    if (keys.includes(PRC_MEETING_SUMMARY_TABLES_KEYS.ALL)) {
      setSelectedKeys(PRC_MEETING_SUMMARY_TABLES_KEYS.ALL);
    } else {
      setSelectedKeys(keys[0]);
    }

    setDisplaySelectedKeys(keys);
  };

  const handleClickApply = () => {
    if (!idMeeting) {
      return;
    }

    const body = {
      selected_key: selectedKeys,
    };

    pdcMeetingApi.updateMeetingPdcSummaryTableView(idMeeting, body).then((res) => {
      const { data } = res;
      setSelectedKeys(data.result.selected_key);
      dispatch(setSelectedKey(data.result.selected_key));
      setOpen(false);
    });
  };

  useEffect(() => {
    if (!idMeeting) {
      return;
    }

    pdcMeetingApi.getMeetingPdcSummaryTableView(idMeeting).then((res) => {
      const { data } = res;
      setSelectedKeys(data.result);
      handleSelectedKeys(data.result);
    });
  }, [idMeeting]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <BasicButton border="1px solid" type="button" onClick={() => setOpen(!open)}>
        <img src={sp_card_setting} alt="" className={styles.icon} />
      </BasicButton>
      <div className={styles.dropdown} style={open ? { zIndex: 10, opacity: 1 } : { zIndex: -10, opacity: 0 }}>
        <div className={styles.list}>
          {PRC_MEETING_SUMMARY_TABLES_OPTIONS.map(({ value, label }) => (
            <div className={styles.row} key={value}>
              <AiCheckBox
                value={value}
                checked={displaySelectedKeys.includes(value)}
                onChange={(e) => {
                  handleSelectedKeys(e.target.value);
                }}
              />{' '}
              {label}
            </div>
          ))}
        </div>
        <div className={styles.btnPreview}>
          <BasicButton mode="teal" type="button" onClick={handleClickApply}>
            Apply
          </BasicButton>
        </div>
      </div>
    </div>
  );
};

export default SummaryConfigButton;
